import { createFileRoute } from '@tanstack/react-router'
import { useRef } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { createServerFn } from '@tanstack/react-start'
import * as v from 'valibot'
import { loadStripe } from '@stripe/stripe-js'
import type { ModalRef } from '@/components/donate/DonationPopup'
import { DonationPopup } from '@/components/donate/DonationPopup'
import { DonationSuccess } from '@/components/donate/DonationSuccess'
import { DonateSectionOne } from '@/components/donate/DonateSectionOne'
import { DonateSectionTwo } from '@/components/donate/DonateSectionTwo'
import { DonateSectionThree } from '@/components/donate/DonateSectionThree'
import { DonateSectionFour } from '@/components/donate/DonateSectionFour'
import { api } from '@/lib/connectivity'

export type DonationResponseType = {
	type: string
	reference: string
	sid: string
	amount: number
	customer: {
		email: string
		name: string
	}
	paymentStatus: string
	status: string
	frequency: string
}

const searchParamsSchema = v.object({
	type: v.optional(v.string()),
	reference: v.optional(v.string()),
	sid: v.optional(v.string()),
})

type searchParamsType = v.InferInput<typeof searchParamsSchema>

const getDonation = createServerFn({ method: 'GET', response: 'data' })
	.validator((search: searchParamsType) => search)
	.handler(async ({ data }) => {
		return await api
			.get<DonationResponseType>(`donate`, {
				params: {
					reference: data.reference,
					sid: data.sid,
					type: data.type,
				},
			})
			.then(({ data }) => data.body)
	})
export const Route = createFileRoute('/donate/')({
	head: () => ({
		meta: [
			{ title: 'Support STD Testing & Care - Donate to WellView Care Today' },
			{
				name: 'description',
				content:
					'Make a difference with your donation to WellView Care. Help us provide essential STD testing and STD treatment services to those in need.',
			},
			{
				name: 'keywords',
				content: 'STD/STI testing, STD Testing, HIV Testing, Fort Lauderdale STD Services, Riviera Beach STD Services',
			},
		],
	}),
	validateSearch: searchParamsSchema,
	loaderDeps: ({ search }) => ({ search }),
	loader: async ({ deps: { search } }) => await getDonation({ data: search }),
	component: RouteComponent,
})

function RouteComponent() {
	const donation = Route.useLoaderData()
	const popupRef = useRef<ModalRef>(null)
	const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY || '')
	const showDonationPopup = () => {
		popupRef.current?.show()
	}
	return donation.type === 'success' ? (
		<DonationSuccess {...donation} />
	) : (
		<Elements stripe={stripePromise}>
			<DonationPopup ref={popupRef} />
			<DonateSectionOne showDonationPopup={showDonationPopup} />
			<DonateSectionTwo />
			<DonateSectionThree />
			<DonateSectionFour showDonationPopup={showDonationPopup} />
		</Elements>
	)
}
